import Store from "./../Store";
import { isBristolFeatureEnabled } from "../features/FeatureChecks";

export const shouldCallCorporateHubEndpoint = () => {
  let currentState = Store.getState();
  let isLocationCorporateHub =
    currentState &&
    currentState.policyReducer &&
    currentState.policyReducer.selectedPolicy &&
    currentState.policyReducer.selectedPolicy.IsLocationCorporateHub;
  return isLocationCorporateHub && isBristolFeatureEnabled();
};
